import { Button, Input } from 'components/atoms';
import ComplexInputWrapper from 'components/atoms/inputs/wrapper/complex/ComplexInputWrapper';
import { FormInput } from 'components/molecules';
import LabelFormStep from 'components/templates/label-form-step/LabelFormStep';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { PiArrowRight } from 'react-icons/pi';
import { CUSTOMER_TYPE, ILabelForm } from 'services/labels/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { getCountriesPhoneNumberPrefixOptionValues } from 'utils/global/countries.utils';

const LabelContactStep = () => {
  const { t } = useTranslation();
  const formik = useFormikContext<ILabelForm>();

  return (
    <LabelFormStep
      header={t('label.form.contact.header')}
      description={t('label.form.contact.description')}
    >
      <div className="flex w-full gap-2 ">
        <FormInput.Text
          name="firstName"
          label={t('input.label.firstName')}
          borderless
          appBackground
        />
        <FormInput.Text
          name="lastName"
          label={t('input.label.lastName')}
          borderless
          appBackground
        />
      </div>
      <FormInput.Text
        name="email"
        label={t('input.label.email')}
        borderless
        appBackground
        fullWidth
      />
      <div className="flex w-full gap-2 ">
        <FormInput.Number
          name="phoneNumberPrefix"
          label={t('input.label.phoneNumberCodeShort')}
          placeholder=""
          prefix="+"
          borderless
          appBackground
        />
        <FormInput.Text
          name="phoneNumber"
          label={t('input.label.phoneNumber')}
          borderless
          appBackground
        />
      </div>
      {formik.values.customerType === CUSTOMER_TYPE.Physical && (
        <FormInput.Text
          max={new Date().toISOString().split('T')[0]}
          min={'1900-01-01'}
          onChange={(e) => {
            const targetValue = e.target.value;
            formik.setFieldValue('dateOfBirth', targetValue);
          }}
          label={t('input.label.dateOfBirth')}
          type="date"
          borderless
          fullWidth
          appBackground
          name="dateOfBirth"
        />
      )}
    </LabelFormStep>
  );
};

export default LabelContactStep;
